// AUTO-GENERATED by scripts/gen-branch-info.mjs — do not edit, do not commit.
export const buildInfo = { branch: '' } as const;
